import { computed, onBeforeUnmount, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/authentication/user.store'
import { useContentAccessStore } from '@/content_access/content_access.store'

// Held open briefly even when there is nothing to load, so the overlay is seen to grow out of
// the page rather than replacing it in a flash that reads as a navigation.
const MINIMUM_PREPARING_MS = 500

/** The state every print preview shares: the opening delay, the trial print quota, and print-then-close. */
export function usePrintPreview(close: () => void) {
  const { printQuota, printCount, printQuotaExceeded } = storeToRefs(useContentAccessStore())
  const { isTrial } = storeToRefs(useUserStore())

  const isTransitioning = ref(true)
  const printsRemaining = computed(() => Math.max(0, printQuota.value - printCount.value))

  function printAndClose(recordPrint: () => void) {
    window.print()
    recordPrint()
    close()
  }

  const transitionTimer = setTimeout(() => {
    isTransitioning.value = false
  }, MINIMUM_PREPARING_MS)
  onBeforeUnmount(() => clearTimeout(transitionTimer))

  return { isTransitioning, isTrial, printQuota, printQuotaExceeded, printsRemaining, printAndClose }
}
